// extracted by mini-css-extract-plugin
module.exports = {"logo":"LandingLogo_logo__kCQ9y"};